





















































import { PropType } from 'vue';
import { defineComponent, toRefs, computed, watch } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import ExpansionPanel from '@/components/common/expansion-panel/index.vue';
import Audience from './index';
import { useStdAdgroupIs } from '@tt4b/ttam-hooks';
import TtamAudience from './audience-base-compose.vue';
import TtamAudienceStocks from './audience-stocks-compose.vue';

const name = 'ttam-audience-compose';
export default defineComponent({
  name,
  components: {
    TtamAudience,
    TtamAudienceStocks,
    ExpansionPanel,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData } = toRefs(props);
    const { isNewAppRetargetingType } = useStdAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });
    const { isOptGoalLPV, audienceDisabledTips } = Audience.usePropsAudienceDisabled({ adgroupData });
    const { isAudienceBasicMode, isConversionRetargetingMode } = Audience.useRetargetingIs({
      adgroupData,
      campaignData,
    });
    const { expansionPanelLabel, expansionPanelLabelTip } = Audience.useExpansionPanelLabel({
      adgroupData,
      campaignData,
    });
    const antiDiscrimination = computed({
      get: () => Boolean(adgroupData.value.antiDiscrimination),
      set: val => {
        emit('anti-discrimination-change', val);
      },
    });
    const { antiDiscriminationVisible, targetAudienceDataHasDeleted } = Audience.usePropsAntiDiscriminationVisible({
      adgroupData,
    });
    const { antiDiscriminationValidator } = Audience.useAntiDiscriminationRule();
    const onIncludeChange = val => {
      emit('include-change', val);
    };
    const onExcludeChange = val => {
      emit('exclude-change', val);
    };
    const onIncludeEventChange = val => {
      emit('include-event-change', val);
    };
    const onExcludeEventChange = val => {
      emit('exclude-event-change', val);
    };
    const onRetargetingTypeChange = val => {
      emit('retargeting-type-change', val);
    };
    watch(
      () => targetAudienceDataHasDeleted.value,
      val => {
        if (val) {
          emit('anti-discrimination-change', false);
        }
      },
      {
        immediate: true,
      },
    );
    return {
      name,
      isAudienceBasicMode,
      isConversionRetargetingMode,
      isOptGoalLPV,
      audienceDisabledTips,
      expansionPanelLabel,
      expansionPanelLabelTip,
      isNewAppRetargetingType,
      antiDiscriminationVisible,
      antiDiscrimination,
      antiDiscriminationValidator,
      onIncludeChange,
      onExcludeChange,
      onIncludeEventChange,
      onExcludeEventChange,
      onRetargetingTypeChange,
    };
  },
});
